var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"stroke":"var(--v-grey-darken-1)","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"M15.464 6.464 19 10M15.464 13.536 19 10M19 10H9.038c-5.384 0-5.384 8 0 8H12"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }